import { Action, Dispatch } from "redux";
import fetchDictionary from "app/umbraco/helpers/fetchDictionary";

export const LOAD_DICTIONARY = "LOAD_DICTIONARY";

export interface LoadDictionaryAction extends Action {
    type: typeof LOAD_DICTIONARY;
    translations: { [key: string]: string };
}

export const thunkLoadDictionary = (url: string) => async (dispatch: Dispatch): Promise<void> => {
    try {
        if (!url) {
            throw new Error();
        }

        const response = await fetchDictionary(url);
        if (response) {
            const action: LoadDictionaryAction = {
                type: LOAD_DICTIONARY,
                translations: response
            };

            dispatch(action);
        }
    }
    catch {
        // TODO: Make catching for dictionary
    }
};

export type DictionaryAction = LoadDictionaryAction;